module.exports = __webpack_public_path__ + "img/client-3.385c7acd.jpg";